import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators  } from '@angular/forms';
import { DocumentsService } from './documents.service';
import { Observable } from 'rxjs';
import { BaseGridComponent } from '../../Core/Abstract/basegrid.component';
import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { SecurityService } from '../../Core/Security/security.service';
import * as moment from 'moment/moment';
import { LogService } from '../../Core/Abstract/log.service';
import { VisualsService } from '../../Core/Abstract/visuals.service';

@Component({
    selector: 'documents-grid',
    templateUrl: './documents.component.html',
    providers : [DocumentsService]
})

export class DocumentsComponent {

    private documents;
    private doctypes = ['docx', 'doc','xls','xlsx','pdf', 'csv', 'txt', 'csv'];
    private errors:any = {};
    private group = 'documents';

    constructor(private documentsService:DocumentsService, 
                private securityService: SecurityService, 
                private logger: LogService, 
                private visualsService: VisualsService,
                private eventsEmitterService: EventsEmitterService){

        this.loadDocuments();
        this.loadErrors();

        this.eventsEmitterService.languageChange.subscribe(
            langId => {
                this.loadErrors();
            }
        );
    }

    private loadDocuments(){
        this.documentsService.getDocuments().subscribe(
            data => {
                if(data.length == 0){
                    this.documentsService.handleError(this.errors['noDocs']); 
                }
                else{
                    this.documents = data;
                }
            },
            error =>{
                this.logger.log(error);
                //this.documentsService.handleError(this.errors['noDocs']); 
            }
        );
    }

    private loadErrors(){
        this.errors = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
    }

    private download(path:string, name:string){
        if(this.doctypes.lastIndexOf(name.substring(name.lastIndexOf(".")+1, name.length).trim())>-1){
            this.documentsService.downloadFile(path, name).subscribe(
                data => {
                    this.logger.log("Downloaded file");
                },
                error => {
                    this.logger.log("Error Dowloading file");
                }
            );   
        }    
    }

}